export const REDUX_SET = '/redux/container/LaunchRentalFlowContainer/set';
export const REDUX_RESET = '/redux/container/LaunchRentalFlowContainer/reset';
